import { Outlet, createFileRoute } from '@tanstack/react-router';

import AppSidebar from '@/components/layout/AppSidebar';
import { ILinkAuth } from '@/utils/linkAuth';
// import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';

const backofficeLinks: ILinkAuth[] = [
  { label: 'Dashboard', to: '/backoffice' },
  { label: 'Customers', to: '/backoffice/customers' },
  { label: 'Settings' },
];

export const Route = createFileRoute('/_authenticated/backoffice')({
  head: () => ({
    meta: [{ title: 'Backoffice' }],
  }),
  component: () => (
    <AppSidebar navItems={backofficeLinks}>
      <Outlet />
    </AppSidebar>
  ),
  beforeLoad: () => {
    // const { session } = useAuthSessionStore.getState();

    const isSuperAdmin = true; // session?.organization?.roles.includes('SUPERADMIN') ?? false;

    if (!isSuperAdmin) {
      throw new Error('You do not have access to this page');
    }
  },
});
